export const IMG = {
  brandingKelp: "https://static.prod-images.emergentagent.com/jobs/b4fa4d50-a58c-47de-9666-ffa15c37e632/images/4f5c3791ec750d53a5de27448f88b2cfaa996dac8a416b1be261499e68fb1a0f.jpeg",
  webFintech: "https://static.prod-images.emergentagent.com/jobs/b4fa4d50-a58c-47de-9666-ffa15c37e632/images/dff6c69f2b6a1960decd9846506e28664895bc3ccb18af8f78611e0a9a781c25.jpeg",
  seoGrowth: "https://static.prod-images.emergentagent.com/jobs/b4fa4d50-a58c-47de-9666-ffa15c37e632/images/bf5b37006835bbb58333144113a3bc8a3e53ffc1f5274b5a7a7f1b3a4d6c6150.jpeg",
  contentEditorial: "https://static.prod-images.emergentagent.com/jobs/b4fa4d50-a58c-47de-9666-ffa15c37e632/images/753ea346fb23a163fa380ab51eccd4d520caeb93c5d93440a7613094a3934a6e.jpeg",
  aiCampaign: "https://static.prod-images.emergentagent.com/jobs/b4fa4d50-a58c-47de-9666-ffa15c37e632/images/20751de5241242e5597afccc8bf758e8ac9cebba65a75b1d7be493149d174f36.jpeg",
  videoProduction: "https://static.prod-images.emergentagent.com/jobs/b4fa4d50-a58c-47de-9666-ffa15c37e632/images/76c10576876073ec8dedae731d4227bc9c6f816e9dd9b0d594fc3e8b9d54f669.jpeg",
  socialCreative: "https://static.prod-images.emergentagent.com/jobs/b4fa4d50-a58c-47de-9666-ffa15c37e632/images/fad3d58f0529790c8ab24961f0cef63328f9a1499b9c6ffbf199a89a2137490d.jpeg",
  marketingLaunch: "https://static.prod-images.emergentagent.com/jobs/b4fa4d50-a58c-47de-9666-ffa15c37e632/images/f3ead26e208e3a6975755bac38a9fba1463f2d50d5fb0dccebcceacbee508270.jpeg",
  brandingCoffee: "https://static.prod-images.emergentagent.com/jobs/b4fa4d50-a58c-47de-9666-ffa15c37e632/images/456b2b1a027776062135570031afc2691ef5ef6d98a3536adbe020f6ee165ded.jpeg",
  portrait: "/images/arnav-portrait.jpg",
};

export const CONTACT = {
  whatsapp: "https://wa.me/919811836484?text=Hi%20Arnav%2C%20saw%20your%20portfolio.%20Let%27s%20talk.",
  email: "mailto:arnavbansal05@gmail.com",
  call: "tel:+919811836484",
  linkedin: "https://www.linkedin.com/in/arnnavk/",
  instagram: "https://www.instagram.com/charming_chaos07",
};

export const FILTERS = ["All", "Branding", "Web", "SEO", "Content", "AI", "Video", "Marketing"];

export const PROJECTS = [
  {
    id: "aura-skincare",
    title: "Aura Skincare",
    category: "Branding",
    year: "2026",
    image: IMG.brandingKelp,
    span: "md:col-span-8",
    ratio: "aspect-[3/2]",
    blurb: "Full identity system for a clean-beauty startup, from logo to packaging to stationery.",
    gallery: [IMG.brandingKelp, "https://static.prod-images.emergentagent.com/jobs/b4fa4d50-a58c-47de-9666-ffa15c37e632/images/4aa439b458f061e00e923d32bcd315be8e84f28b33e7c413fd458c7b87e906de.jpeg"],
    result: "+180% shelf recall in first retail test",
  },
  {
    id: "beeta-logistics",
    title: "Beeta Logistics",
    category: "Web",
    year: "2026",
    image: "/images/beeta-web.jpg",
    span: "md:col-span-4",
    ratio: "aspect-[3/2]",
    blurb: "Corporate website for India's integrated 3PL, covering warehousing, transport and auto logistics with a 60-second instant-quote flow.",
    gallery: ["/images/beeta-web.jpg", "/images/gallery/beeta-1.jpg", "/images/gallery/beeta-2.jpg"],
    result: "Trusted by 100+ clients incl. Yamaha, Honda & Tata Motors",
  },
  {
    id: "bloom-chrome",
    title: "Bloom / Chrome",
    category: "AI",
    year: "2025",
    image: IMG.aiCampaign,
    span: "md:col-span-4",
    ratio: "aspect-[3/4]",
    blurb: "AI-generated hero visuals for a fashion week campaign, made with zero photoshoot budget.",
    gallery: [IMG.aiCampaign, "https://static.prod-images.emergentagent.com/jobs/b4fa4d50-a58c-47de-9666-ffa15c37e632/images/e60f85202265b12eee1dc4085be6d68bd84597e4903efa36d8c36153cc9e13a0.jpeg"],
    result: "2.1M impressions organically",
  },
  {
    id: "ridedoc",
    title: "RideDoc",
    category: "Web",
    year: "2026",
    image: "https://static.prod-images.emergentagent.com/jobs/b4fa4d50-a58c-47de-9666-ffa15c37e632/images/21b108ca8c098067b8c186a86d41431893e93fab000503f7162688236bf42bb7.jpeg",
    span: "md:col-span-8",
    ratio: "aspect-[3/2]",
    blurb: "Brand, website and WhatsApp booking funnel for a doorstep car-service startup in Delhi NCR. Book in 60 seconds.",
    gallery: ["https://static.prod-images.emergentagent.com/jobs/b4fa4d50-a58c-47de-9666-ffa15c37e632/images/21b108ca8c098067b8c186a86d41431893e93fab000503f7162688236bf42bb7.jpeg", "/images/gallery/ridedoc-1.jpg", "/images/gallery/ridedoc-2.jpg"],
    result: "15k+ cars serviced · 4.8★ average rating",
  },
  {
    id: "folio-editorial",
    title: "Folio Quarterly",
    category: "Content",
    year: "2025",
    image: IMG.contentEditorial,
    span: "md:col-span-5",
    ratio: "aspect-square",
    blurb: "Editorial direction, copy and layout for a design publication.",
    gallery: [IMG.contentEditorial, "https://static.prod-images.emergentagent.com/jobs/b4fa4d50-a58c-47de-9666-ffa15c37e632/images/6a0394c0ee885e77dd4f6993642543632b068d487bcae43eb5ded041532a56fa.jpeg"],
    result: "Sold out two print runs",
  },
  {
    id: "rank-one",
    title: "Rank One",
    category: "SEO",
    year: "2026",
    image: IMG.seoGrowth,
    span: "md:col-span-3",
    ratio: "aspect-square",
    blurb: "Technical SEO + content strategy for a B2B SaaS.",
    gallery: [IMG.seoGrowth, "https://static.prod-images.emergentagent.com/jobs/b4fa4d50-a58c-47de-9666-ffa15c37e632/images/1f99a0756920c2d3c3e582ba97d5e965000303f16493e1b54203ad191678285b.jpeg"],
    result: "0 → 48K monthly organic visits",
  },
  {
    id: "pulse-social",
    title: "Pulse",
    category: "Marketing",
    year: "2026",
    image: IMG.socialCreative,
    span: "md:col-span-4",
    ratio: "aspect-[3/4]",
    blurb: "A 90-day social creative system with templates, motion posts and reels covers.",
    gallery: [IMG.socialCreative, "https://static.prod-images.emergentagent.com/jobs/b4fa4d50-a58c-47de-9666-ffa15c37e632/images/7172b6644bc8ef83945057619e496153aacf501657e6dc6e4aff4f1926d4bc5a.jpeg"],
    result: "+312% engagement rate",
  },
  {
    id: "creative-lab",
    title: "Creative Lab",
    category: "Video",
    year: "2025",
    image: IMG.videoProduction,
    span: "md:col-span-7",
    ratio: "aspect-[3/2]",
    blurb: "Direction and edit of a 60s brand film + 12 short-form cutdowns.",
    gallery: [IMG.videoProduction, "https://static.prod-images.emergentagent.com/jobs/b4fa4d50-a58c-47de-9666-ffa15c37e632/images/57d9595948969b7e6093fa3854a63e5ec8034b7a61e0857d53e97f74264a2a98.jpeg"],
    result: "8.4M views across platforms",
  },
  {
    id: "hashtag-agency",
    title: "Hashtag",
    category: "Branding",
    year: "2026",
    image: "/images/hashtag-brand.jpg",
    span: "md:col-span-5",
    ratio: "aspect-square",
    blurb: "Identity and digital presence for an integrated brand & communications agency in Delhi NCR.",
    gallery: ["/images/hashtag-brand.jpg", "/images/gallery/hashtag-1.jpg", "/images/gallery/hashtag-2.jpg"],
    result: "Brands people notice, remember and choose",
  },
];

export const CASE_STUDIES = [
  {
    num: "01",
    title: "RideDoc",
    tag: "Brand + Web",
    image: "https://static.prod-images.emergentagent.com/jobs/b4fa4d50-a58c-47de-9666-ffa15c37e632/images/21b108ca8c098067b8c186a86d41431893e93fab000503f7162688236bf42bb7.jpeg",
    challenge: "A doorstep car-service startup in Delhi NCR needed a brand people would trust with their cars, plus a booking flow simple enough for a WhatsApp message.",
    made: "The full identity, a conversion-first website and a WhatsApp booking funnel that gets a car booked in under 60 seconds.",
    result: "15k+ cars serviced and a 4.8 star average rating across bookings.",
  },
  {
    num: "02",
    title: "Beeta Logistics",
    tag: "Corporate Web",
    image: "/images/beeta-web.jpg",
    challenge: "An integrated 3PL covering warehousing, transport and auto logistics had a site that hid its scale and made getting a quote slow.",
    made: "A corporate website that lays out every service clearly and turns enquiries into a 60-second instant-quote flow.",
    result: "Trusted by 100+ clients including Yamaha, Honda and Tata Motors.",
  },
  {
    num: "03",
    title: "Hashtag",
    tag: "Branding",
    image: "/images/hashtag-brand.jpg",
    challenge: "An integrated brand and communications agency in Delhi NCR needed an identity as sharp as the work they sell.",
    made: "A confident identity and digital presence, built to feel premium across every touchpoint.",
    result: "Brands people notice, remember and choose.",
  },
];

export const SERVICES = [
  {
    group: "Brand",
    items: ["Brand identity", "Logo systems", "Packaging", "Brand guidelines"],
    desc: "The face people remember.",
  },
  {
    group: "Digital",
    items: ["Website design", "Development", "Landing pages", "SEO"],
    desc: "Where they find and choose you.",
  },
  {
    group: "Content",
    items: ["Copywriting", "AI image generation", "Video creation", "Social media creative"],
    desc: "What keeps them watching.",
  },
  {
    group: "Growth",
    items: ["Marketing strategy", "Campaigns", "Analytics", "Funnels"],
    desc: "What turns attention into revenue.",
  },
];

export const TESTIMONIALS = [
  {
    quote: "People trust us with their cars, and the brand Arnav built earns that on day one. His WhatsApp booking is so simple customers thank us for it.",
    name: "Pranay Aggrawal",
    role: "CEO, RideDoc",
    stat: "15k+",
    statLabel: "cars serviced",
  },
  {
    quote: "Our old site made a serious company look small. Arnav rebuilt it to show our scale, and the instant-quote flow lands leads in seconds.",
    name: "Chiraag Shridhar",
    role: "Director, Beeta Logistics",
    stat: "100+",
    statLabel: "enterprise clients",
  },
  {
    quote: "He got the brief on the first call and ran with it. The identity feels premium without trying too hard, and it has held up everywhere since.",
    name: "Gulnar Virk",
    role: "Founder, HashTag Marketing",
    stat: "2.4×",
    statLabel: "inbound enquiries",
  },
];
